import { render, staticRenderFns } from "./TermsConditionCreate.vue?vue&type=template&id=24bbe406&"
import script from "./TermsConditionCreate.vue?vue&type=script&lang=js&"
export * from "./TermsConditionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports